import {
  TileKit,
  MakeModel,
  TrimMileage,
  InventoryType
} from '@carvana/merch-search';
import type React from 'react';
import PriceAndTerms from './PriceAndTerms';
import useMiddleFrameEvents from './useMiddleFrameEvents';

type BaseMiddleFrameProps = {
  openSoftPullModal: () => void;
};

const MiddleFrame: React.FC<BaseMiddleFrameProps> = ({ openSoftPullModal }) => {
  const { trackMarketPlaceClicked, ...mappedEvents } = useMiddleFrameEvents();

  return (
    <TileKit.Frame className="middle-frame">
      <TileKit.Pane fullWidth>
        <InventoryType trackMarketPlaceClicked={trackMarketPlaceClicked} />
        <MakeModel />
        <TrimMileage />
      </TileKit.Pane>
      <PriceAndTerms
        mappedAnalyticsEvents={mappedEvents}
        openSoftPullModal={openSoftPullModal}
      />
    </TileKit.Frame>
  );
};

export default MiddleFrame;
